module.exports = __webpack_public_path__ + "img/affiliate-7.698f486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/affiliate-7.png
// module id = 1621
// module chunks = 1